const tokens = {
  size: {
    sidebarWidth: 300,
    headerHeight: 72,
    searchWidth: 188,
    tableOfContentsWidth: 180,
    base: 10,
    heroHeight: 500,
  },
  breakpoint: {
    xl: 1012,
    l: 768,
    m: 544,
  },
  color: {
    white: "#fff",
    black: "#000",
    primaryLight: "#6499ed",
    primary: "#357DED",
    primaryDark: "#1360dd",
    primaryTransparent: "rgba(53,125,237,0.09)",
    bgDark: "#3F3F46",
    bgLight: "#E5E5E5",
    bgInput: "#56565c",
    text: {
      base: "#1b1f23",
      light: "#a8a8a8",
      invert: "#fafbfc",
      muted: "#808080",
    },
    border: "#E5E5E5",
    boxShadow: "rgba(225, 228, 232, 0.2)",
    success: "#28a745",
    error: "#d73a49",
    accent: "#dbab09",
  },
  font: {
    base: 'Lato, "Lucida Grande", Tahoma, Sans-Serif',
    mono: 'SFMono-Regular,Consolas,"Liberation Mono",Menlo,Courier,monospace',
  },
  fontSize: {
    heading: {
      xxl: "64px",
      xl: "36px",
      l: "24px",
      m: "20px",
      s: "18px",
      xs: "14px",
    },
    text: {
      base: "16px",
      s: "15px",
      xs: "10px",
    },
  },
}

export default tokens
